import Inline from '../blots/inline';

class Underline extends Inline {
  static blotName = 'underline';
  static tagName = 'U';
}

export default Underline;
